import { UseQueryResult } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';

export const useStreamFileDownload = (
  service: (id: string, enabled?: boolean) => UseQueryResult<Blob, Error>
) => {
  const [file, setFile] = useState<{
    id: string;
    name: string;
    extension?: string;
  } | null>();

  const streamedFile = service(file?.id ?? '', false);

  useEffect(() => {
    if (file?.id) {
      streamedFile.refetch();
    }
  }, [file?.id]);

  useEffect(() => {
    if (streamedFile.data && file) {
      const url = window.URL.createObjectURL(streamedFile.data);
      const a = document.createElement('a');
      a.href = url;
      a.download = `${file.name}.${file.extension ?? 'pdf'}`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
      setFile(null);
    }
  }, [streamedFile.data]);

  useEffect(() => {
    if (file && streamedFile.isLoading) {
      toast.loading(file.name, { id: file.id });
      return;
    }
    if (file && streamedFile.status === 'success') {
      toast.success(file.name, { id: file.id });
      return;
    }
    if (file && streamedFile.status === 'error') {
      toast.error(file.name, { id: file.id });
      return;
    }
  }, [streamedFile.isLoading, streamedFile.status]);

  return { setFile, isLoading: streamedFile.isLoading };
};
